// Google Analytics 4 helpers — wraps window.gtag with safe no-op fallback.
// Configured base script lives in /app/frontend/public/index.html (G-J135V4JQME).

const GA_ID = "G-J135V4JQME";

const safeGtag = (...args) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try { window.gtag(...args); } catch (e) { /* swallow */ }
};

/**
 * SPA pageview — call on every route change.
 */
export const trackPageview = (path) => {
  safeGtag("event", "page_view", {
    page_path: path,
    page_location: typeof window !== "undefined" ? window.location.href : "",
    send_to: GA_ID,
  });
};

/**
 * Generic event helper.
 *  trackEvent('whatsapp_click', { source: 'floating' })
 */
export const trackEvent = (name, params = {}) => {
  safeGtag("event", name, { send_to: GA_ID, ...params });
};

// Convenience helpers per business goal
export const trackWhatsAppClick = (source) =>
  trackEvent("whatsapp_click", { source });

export const trackQuoteSubmit = (params = {}) =>
  trackEvent("generate_lead", { lead_type: "quote", ...params });

export const trackSampleKitSubmit = (params = {}) =>
  trackEvent("generate_lead", { lead_type: "sample_kit", ...params });

export const trackMeetingBooked = (params = {}) =>
  trackEvent("generate_lead", { lead_type: "meeting", ...params });

export const trackCareerApply = (params = {}) =>
  trackEvent("generate_lead", { lead_type: "career_application", ...params });
